import { createContext } from 'react';

export type SidepanelContextValue = [
  string | null,
  (id: string) => void,
  () => void,
];

export const SidepanelContext = createContext<SidepanelContextValue | null>(
  null,
);
